import './lib/polyfill';
import EncryptionSDK from './lib';
new EncryptionSDK();
